module.exports = __webpack_public_path__ + "img/brand_siemens.4501d158.webp";